import { NOTIFICATION_HEADLINE_CLASSNAME } from '@vfde-brix/ws10/notification';
import { ResultHtmlId, TariffHtmlId } from '../enums/elementId';

const DISPLAY_METACODE_ATTRIBUTE = 'data-metacode';

const setDisplayMetacodeAttribute = (element: Element | null | undefined, metacode: string) => {
    element && element.setAttribute(DISPLAY_METACODE_ATTRIBUTE, metacode);
};

/**
 * Set [*data-metacode*] attribute for an Element
 * @param elementOrId The [*data-metacode*] attribute will added to this element
 * @param metacode The value of the [*data-metacode*] attribute
 */
export const setDisplayMetacode = (elementOrId: Element | string, metacode: string) => {
    const element = ('string' === typeof elementOrId)
        ? document.getElementById(elementOrId)
        : elementOrId;

    setDisplayMetacodeAttribute(element, metacode);
};

/**
 * Setup Tariff Picker Brix component to support the Display Metacodes tool
 */
export const addDisplayMetacodeToTariffPicker = () => {
    const wrapperEl = document.getElementById(TariffHtmlId.TARIFF_PICKER);
    const inputs = wrapperEl?.getElementsByTagName('input');
    const labels = wrapperEl?.getElementsByTagName('label');

    if (!inputs || !labels || inputs.length !== labels.length) {
        return;
    }

    for (let i = 0; i < labels.length; i++) {
        setDisplayMetacodeAttribute(labels[i], inputs[i]?.value || '');
    }
};

/**
 * Setup AVC Result Notification component to support the Display Metacodes tool
 */
export const addDisplayMetacodeToAvcResult = (metacode: string) => {
    const resultEl = document.getElementById(ResultHtmlId.NOTIFICATION);
    const [ headlineEl ] = resultEl?.getElementsByClassName(NOTIFICATION_HEADLINE_CLASSNAME) || [];

    setDisplayMetacodeAttribute(headlineEl, metacode);
};
